<template>
  <!-- 这里可以作为theme应用的元素 -->
  <el-container id="preview">
    <!-- 头部 -->
    <HeaderSection
      v-if="menuDirectionType !== 'true'"
      :title="currentProject.title"
      :menuDirectionType="menuDirectionType"
    >
      <HorizontalMenu
        :horizontal-menu="menuList.horizontalMenu"
        :active="mixedHorizontalActive"
        @mixed-menu-click="setVerticalMenu"
      ></HorizontalMenu>
    </HeaderSection>

    <div class="main-wrapper">
      <!-- 左侧垂直菜单 -->
      <VerticalMenu
        v-show="!hideMenu && menuList.verticalMenu.length"
        :vertical-menu="menuList.verticalMenu"
        :title="currentProject.title"
        :menuDirectionType="menuDirectionType"
      />
      <el-main v-show="showMain" :style="[pageStyle]">
        <!-- 缓存列表 -->
        <KeepAliveRoutes v-if="isOpenKeepAlive && !isSystemMenu"></KeepAliveRoutes>
        <div class="router-warpper">
          <router-view v-slot="{ Component }">
            <Transition name="fade">
              <keep-alive>
                <component :is="Component" v-if="$route.meta.keepAlive" :key="$route.path" />
              </keep-alive>
            </Transition>

            <Transition name="fade">
              <component :is="Component" v-if="!$route.meta.keepAlive" :key="$route.path" />
            </Transition>
          </router-view>
        </div>
      </el-main>
      <!-- <el-footer>版权所有 &copy; {{ getCurrentYear() }} 北京浩瀚深度信息技术股份有限公司</el-footer> -->
    </div>
    <!-- 4A金库主入口 -->
    <JKAuthDialog />
  </el-container>
</template>

<script setup lang="ts">
  import { useProject } from '@haohan/clw-store'
  import { computed, nextTick, onBeforeMount, reactive, ref, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import HeaderSection from './components/HeaderSection.vue'
  import HorizontalMenu from './components/HorizontalMenu.vue'
  import KeepAliveRoutes from './components/KeepAlive.vue'
  import VerticalMenu from './components/VerticalMenu.vue'
  import { setMenuColor } from './setMenuColor'
  import { JKAuthDialog } from '@haohan/clw-4a'
  setMenuColor()

  const projectStore = useProject()
  const route = useRoute()
  const projectId = ref('')
  const activatedRouteKey = computed(() => projectStore.previewKeepAliveRoute.activatedRouteKey)
  const menuDirectionType = computed(() => currentProject.value?.settings?.verticalMenu || 'false')

  //菜单--------开始
  const menuList = reactive<{
    verticalMenu: any[]
    horizontalMenu: any[]
  }>({
    verticalMenu: [],
    horizontalMenu: []
  })

  const horizontalFlattenMenu = ref<any[]>([]) //菜单扁平化，方便后续查找根节点菜单

  async function getProjectMenus() {
    //移除隐藏的菜单
    function removeHideMenu(menulist: Menu[]) {
      return menulist.filter((menu) => {
        if (menu.hidden || menu.title === '非菜单页面') {
          return false
        }
        if (menu.children) {
          menu.children = removeHideMenu(menu.children)
        }
        return true
      })
    }

    if (projectId.value) {
      const originMenus = projectStore.pages || []
      const showMenu = removeHideMenu(originMenus)
      const menus = showMenu.filter((menu: Menu) => {
        // 过滤掉没有页面的空文件夹
        return !(menu.type === 'MENU' && (!menu.children || menu.children.length === 0))
      })
      if (menuDirectionType.value === 'true') {
        menuList.verticalMenu = menus
        menuList.horizontalMenu = []
      } else if (['false', 'mixed'].includes(menuDirectionType.value)) {
        menuList.horizontalMenu = menus
        horizontalFlattenMenu.value = flattenTree(
          JSON.parse(JSON.stringify(menuList.horizontalMenu))
        )
        setVerticalMenu(activatedRouteKey.value)
      }
    }
  }

  const currentProject = computed(() => {
    return projectStore.currentProject
  })

  // 表单页, 是否展示面包屑
  const isFormPage = computed(() => {
    const pageType = projectStore?.currentPage?.variables?.pageType
    return pageType === 'form'
  })

  watch(
    () => projectStore.currentModule.id,
    () => {
      getProjectMenus()
    }
  )

  const mixedHorizontalActive = ref('')
  const showMain = ref(menuDirectionType.value === 'mixed' ? false : true)
  function setVerticalMenu(pageId: string) {
    const id = pageId ? pageId : (route.params?.pageId as string)
    if (
      currentProject.value?.settings?.verticalMenu === 'mixed' &&
      horizontalFlattenMenu.value.length > 0
    ) {
      showMain.value = false
      let parent = menuList.horizontalMenu[0]
      function getParents(menu: Menu[], id: string) {
        const cur = menu.find((item) => {
          return item.id === id
        })
        if (cur?.parentId === 0) {
          parent = cur
        } else {
          if (!cur) return
          getParents(menu, cur?.parentId)
        }
      }
      if (id) {
        getParents(horizontalFlattenMenu.value, id)
      }
      mixedHorizontalActive.value = `/preview/${parent.projectId}/${parent.moduleId}/${parent.id}`
      //回显激活菜单
      menuList.verticalMenu = parent?.children || []
      nextTick(() => {
        showMain.value = true
      })
    }
  }

  function flattenTree(menuList: Menu[]): Menu[] {
    const flatList = []
    function flatten(menuList: Menu[]) {
      menuList.forEach((item) => {
        if (item.children) {
          flatten(item.children)
        }
        flatList.push(item)
      })
    }

    flatten(menuList)
    return flatList
  }

  onBeforeMount(() => {
    projectId.value = `${route.params.projectId || projectStore.currentProject.id} `
    getProjectMenus()
  })

  const pageStyle = computed(() => {
    const bgColor = projectStore?.currentPage?.variables?.bgColor
    // 表单页
    if (!bgColor && bgColor !== '' && isFormPage.value) {
      return { backgroundColor: '#fff' }
    }
    return bgColor && bgColor !== '' ? { backgroundColor: bgColor } : {}
  })

  // 是否开启 keep-alive
  const isOpenKeepAlive = computed(() => projectStore.previewKeepAliveRoute.isOpenKeepAlive)
  /**
   * watch route.params
   * /preview 则增加自定义路由 用于 keep_alive
   * /preview_ 则不处理
   * @param projectId
   * @param pageId
   */
  const addCustomRoute = () => {
    const { projectId, pageId } = route.params
    const { path } = route
    projectStore.addPreviewKeepAliveRoute({
      pageId,
      projectId,
      key: pageId,
      path: path,
      fullPath: path
    })
  }

  watch(
    () => projectStore.currentPage,
    () => {
      if (projectStore?.currentPage?.id) {
        // 更新 store, tag 标题
        projectStore.updateActivatedRouteTitle(
          String(route.params?.pageId),
          projectStore.currentPage.title
        )
      }
    }
  )

  watch(
    () => route.path,
    () => {
      if ('previewLayoutIndex' !== route.name) {
        projectStore.updateActivatedRouteKey('system-menu')
        return
      } else {
        if (route.query.reload) {
          location.reload()
        }
      }
      // 添加自定义路由
      addCustomRoute()
    },
    {
      immediate: true
    }
  )

  // 菜单是否隐藏
  const hideMenu = ref(false)
  watch(
    () => route.query,
    () => {
      hideMenu.value = route.query?.hideMenu === 'true'
    },
    { immediate: true }
  )

  const isSystemMenu = ref(false) //
  function changeActivatedRouteKey(val: string, oldVal: string) {
    //特殊处理系统隐藏菜单
    if (val === 'system-menu') {
      mixedHorizontalActive.value = ''
      if (menuDirectionType.value !== 'true') {
        menuList.verticalMenu = []
      }
      isSystemMenu.value = true
    } else {
      isSystemMenu.value = false
      if (oldVal === 'system-menu') {
        getProjectMenus()
      } else {
        setVerticalMenu(val)
      }
    }
  }

  watch(activatedRouteKey, (val, oldVal) => {
    changeActivatedRouteKey(val, oldVal)
  })
</script>

<style scoped lang="scss">
  .el-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    --el-menu-horizontal-height: 52px;

    .main-wrapper {
      flex: 1;
      display: flex;
      overflow: hidden;
    }

    .el-main {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding: 0;
      .router-warpper {
        flex: 1;
        padding: 10px;
        box-sizing: border-box;
        overflow: scroll;
      }
    }
    .el-footer {
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-size: 12px;
      color: var(--font-color-tip);
    }
  }

  .open-keep-alive {
    padding-top: 12px !important;
  }
</style>
